import {tagColors} from "@/components/tag/tag-colors";
export const MarketEnum = {
  regionOption: [
    {id: 'na', text: '北美区'},
    {id: 'eu', text: '欧洲区(包括中东和印度)'},
    {id: 'fe', text: '远东区'},
  ],
  adsAuthStatusOption: [
    {id: 'Unauthorized', text: '未授权'},
    {id: 'NotOpen', text: '未开通'},
    {id: 'Success', text: '授权成功'},
    {id: 'Fail', text: '授权失败'},
  ],
  spApiAuthStatusOption: [
    {id: 'Success', text: '授权成功'},
    {id: 'Fail', text: '授权失败'},
    {id: 'Expired', text: '已过期'},
  ],
  statusOption: [
    {id: 'Active', text: '启用',...tagColors.greenText},
    {id: 'Inactive', text: '停用', ...tagColors.gray9Text},
  ],
  areaOption: [
    {text: '北美区', id: 'na', countryOption: [
        {id: 'US', text: '美国'},
        {id: 'CA', text: '加拿大'},
        {id: 'MX', text: '墨西哥'},
        {id: 'BR', text: '巴西'},
      ]},
    {text: '欧洲区(包括中东)', id: 'eu', countryOption: [
        {id: 'ES', text: '西班牙'},
        {id: 'UK', text: '英国'},
        {id: 'FR', text: '法国'},
        {id: 'DE', text: '德国'},
        {id: 'IT', text: '意大利'},
        {id: 'TR', text: '土耳其'},
        {id: 'NL', text: '荷兰'},
        {id: 'SE', text: '瑞典'},
        {id: 'PL', text: '波兰'},
      ]},
    {text: '新加坡', id: 'SG', countryOption: []},
    {text: '澳大利亚', id: 'AU', countryOption: []},
    {text: '日本', id: 'JP', countryOption: []},
    {text: '印度', id: 'IN', countryOption: []},
    {text: '阿联酋', id: 'AE', countryOption: []},
    {text: '沙特阿拉伯', id: 'SA', countryOption: []},
  ],
    emailOption: [
        {id: 'qq', text:'QQ邮箱', append:'@qq.com', type: 'code', IMAP: ['imap.qq.com'], SSL: '993', TLS: null},
        {id: 'exmail.qq', text:'腾讯企业邮箱', append:'', type: 'code', IMAP: ['imap.exmail.qq.com'], SSL: '993', TLS: null},
        {id: '126', text:'126邮箱', append:'@126.com', type: 'code', IMAP: ['imap.126.com'], SSL: '993', TLS: null},
        {id: '163', text:'163邮箱', append:'@163.com', type: 'code', IMAP: ['imap.163.com'], SSL: '993', TLS: null},
        {id: 'qiye.163', text:'163企业邮箱', append:'', type: 'code', IMAP: ['imaphz.qiye.163.com', 'imaphm.qiye.163.com'], SSL: '993', TLS: null},
        {id: '139', text:'139邮箱', append:'@139.com', type: 'code', IMAP: ['imap.139.com'], SSL: '993', TLS: null},
        {id: 'Yahoo', text:'Yahoo邮箱', append:'@yahoo.com', type: 'code', IMAP: ['imap.mail.yahoo.com'], SSL: '993', TLS: null},
        {id: 'AOL', text:'AOL邮箱', append:'@aol.com', type: 'code', IMAP: ['imap.aol.com'], SSL: '993', TLS: null},
        {id: 'aliyun', text:'阿里云邮箱', append:'@aliyun.com', type: 'code', IMAP: ['imap.aliyun.com'], SSL: '993', TLS: null},
        {id: 'qiye.aliyun', text:'阿里云企业邮箱', append:'', type: 'code', IMAP: ['imap.qiye.aliyun.com'], SSL: '993', TLS: null},
        {id: 'sohu', text:'sohu邮箱', append:'@sohu.com', type: 'code', IMAP: ['imap.sohu.com'], SSL: '993', TLS: null},
        {id: 'sina', text:'sina邮箱', append:'@sina.com', type: 'code', IMAP: ['imap.sina.com', 'imap.sina.cn'], SSL: '993', TLS: null},
        {id: 'Hotmail', text:'Hotmail邮箱', append:'@hotmail.com', type: 'passWord', IMAP: [''], SSL: '993', TLS: null},
        {id: 'Gmail', text:'Gmail邮箱', append:' @gmail.com ', type: 'passWord', IMAP: ['imap.gmail.com'], SSL: '993', TLS: null},
        {id: 'outlook', text:'outlook邮箱', append:'', type: 'passWord', IMAP: ['imap-mail.outlook.com', 'pop-mail.outlook.com', 'outlook.office365.com'], SSL: null, TLS: '993'},
        {id: 'noMail', text:'以上都没有，手动输入', append:'', type: null, IMAP: [''], SSL: '993', TLS: null},
    ]
};
